import "../../global.css";
import { useState } from "react";
import * as XLSX from "xlsx";
import { userRequest } from "../../requestMethods";
import Swal from "sweetalert2";
import Loading from "../../components/loading/loading";
import { generateFileUrl } from "../../requestMethods";
import Button from "@mui/material/Button";
import CompanySelect from "../../components/CompanySelect";
import CustomGrid from "../../components/grid/CustomGrid";

export default function ImportCustomer() {
  const [dataXLS, setDataXLS] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [companyId, setCompanyId] = useState();

  const columns = [
    {
      field: "name",
      align: "left",
      headerName: "Nome",
      width: 200,
      headerClassName: "dataGridMuiHeader",
    },
    {
      field: "cnpj_cpf",
      headerName: "CNPJ",
      headerClassName: "dataGridMuiHeader",
      width: 200,
      align: "left",
    },
    {
      field: "contact",
      headerName: "Celular",
      headerClassName: "dataGridMuiHeader",
      width: 200,
      align: "left",
    },
    {
      field: "email",
      headerName: "Email",
      width: 160,
      align: "left",
      headerClassName: "dataGridMuiHeader",
    },
    {
      field: "managed",
      headerName: "Vendedor(a)",
      headerClassName: "dataGridMuiHeader",
      width: 200,
      align: "left",
    },
  ];

  const _replacetel = (contact) => {
    if (contact !== "") {
      return contact
        .toString()
        .replace("(", "")
        .replace(")", "")
        .replace("-", "")
        .replace(".", "");
    }
    return contact;
  };

  const addXLS = async () => {
    setIsLoading(true);
    if (dataXLS.length > 0) {
      const customer = Array.from(dataXLS).map((item) => ({
        name: item.name,
        cnpj_cpf: item.cnpj_cpf,
        contact: _replacetel(item.contact),
        email: item.email,
        managedBy: item.managed,
        enabled: "Aprovado",
      }));

      const res = await userRequest.post(
        `${companyId}/customers/registerShortCustomer`,
        customer
      );

      if (Object.keys(res.data).length > 0) {
        Swal.fire(
          "Parabéns!",
          "Aguardar o preenchimento dos dados faltantes!",
          "success"
        );
        setIsLoading(false);
        await userRequest.get(`${companyId}/customers/fixCNPJ`);
      } else {
        Swal.fire("Atenção!", "Erro ao inserir cliente!", "error");
      }
    } else {
      Swal.fire("Atenção!", "Favor selecionar um aquivo!", "warning");
    }
    setIsLoading(false);
  };

  const handleFileUpload = (e) => {
    const reader = new FileReader();
    reader.readAsBinaryString(e.target.files[0]);
    reader.onload = (e) => {
      const data = e.target.result;
      const workbook = XLSX.read(data, { type: "binary" });

      if (validaFile(workbook)) {
        const index = workbook.SheetNames.findIndex(
          (item) => item === "Clientes"
        );
        const sheetName = workbook.SheetNames[index];
        const sheet = workbook.Sheets[sheetName];

        sheet["A1"].w = "name";
        sheet["B1"].w = "cnpj_cpf";
        sheet["C1"].w = "contact";
        sheet["D1"].w = "email";
        sheet["E1"].w = "managed";

        const parsedData = XLSX.utils.sheet_to_json(sheet);
        setDataXLS(parsedData);
      } else {
        Swal.fire("Erro!", "Estrutura do arquivo modificada.", "warning");
      }
    };
  };

  const validaFile = (workbook) => {
    const index = workbook.SheetNames.findIndex((item) => item === "Clientes");
    const sheetName = workbook.SheetNames[index];
    const sheet = workbook.Sheets[sheetName];

    if (index === -1) return false;
    if (sheet["A1"].v !== "Nome") return false;
    if (sheet["B1"].v !== "CNPJ") return false;
    if (sheet["C1"].v !== "Celular") return false;
    if (sheet["D1"].v !== "Email") return false;
    if (sheet["E1"].v !== "Vendedor") return false;
    return true;
  };

  let downalodFIle = generateFileUrl("ImportFiles/ImportShortCustomer.xlsx");

  return (
    <div className="div_custom_">
      {isLoading ? (
        <Loading />
      ) : (
        <div className="div_custom_Container">
          <CompanySelect onSelect={(companyId) => setCompanyId(companyId)} />
          <div className="div_custom_UpdateList">
            <div>
              <input
                id="selecao-arquivo"
                type="file"
                accept=".xlsx, .xls"
                onChange={handleFileUpload}
              />
            </div>
            <div>
              <Button
                className="custom_add_top"
                size="small"
                variant="outlined"
                color="secondary"
                onClick={addXLS}
              >
                Importar Excel
              </Button>
            </div>
            <div>
              <labe>Informações para importação de clientes</labe>
              <br></br>
            </div>
            <div className="custom_label">
              <labe>
                1. O arquivo deve ser utilizado na mesma estrutura de download.
                <a href={downalodFIle} download>
                  Download Arquivo
                </a>
              </labe>
            </div>
            <div className="custom_label">
              <labe>
                2. Os campos de CNPJ e Celular devem ser apenas númenros
              </labe>
            </div>
            <div>
              <br></br>
              <CustomGrid
                gridId="importCustomer"
                getRowId={(row) => row.contact}
                rows={dataXLS}
                columns={columns}
                pageSize={8}
                tableHeight="500px"
              />
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
